import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { useModal } from '@hooks/app/modal.hook'
import { useCreateFormModel } from '@hooks/form-model/create-form-model.hook'

import { Modal } from '@components/Modal'

import { FormBuilder } from '../../components/FormBuilder/FormBuilder.component'
import { fieldsAreValid, transformFormModelStructureToInput } from '../../components/FormBuilder/FormBuilder.helper'

import { FormField, FormModelValidationConfigModel, FormModelValidationMode, LocalFile } from '@types'

import { Container } from './add-form-model.styled'

export const AddFormModelPage = () => {
  const { hideModal } = useModal()
  const { t } = useTranslation()
  const { projectId } = useParams()

  const { createFormModel } = useCreateFormModel()

  const [title, setTitle] = useState<string>('')
  const [fields, setFields] = useState<FormField[]>([])
  const [localFiles, setLocalFiles] = useState<Record<string, LocalFile[]>>({})
  const [validationConfig, setValidationConfig] = useState<FormModelValidationConfigModel | undefined>({
    allowAdminEdit: false,
    mode: FormModelValidationMode.OnChange,
  })

  const handleOnSubmit = () => {
    if (projectId && validationConfig) {
      createFormModel(
        {
          projectId,
          title,
          structure: transformFormModelStructureToInput(fields, validationConfig),
        },
        localFiles,
      )

      hideModal('add_form_model')
    }
  }

  const formIsValid = fieldsAreValid(fields)
  const isDisabled = !formIsValid

  return (
    <Modal
      title={t('modules_project-settings_pages_add_form-model_title')}
      onSubmitLabel={t('modules_project-settings_pages_add_form_model_button_add_form')}
      onClose={() => hideModal('add_form_model')}
      onSubmit={handleOnSubmit}
      disabledSubmitButton={isDisabled}
    >
      <Container>
        {projectId && (
          <FormBuilder
            title={title}
            projectId={projectId}
            setTitle={setTitle}
            validationConfig={validationConfig}
            setValidationConfig={setValidationConfig}
            fields={fields}
            setFields={setFields}
            setLocalFiles={setLocalFiles}
          />
        )}
      </Container>
    </Modal>
  )
}
